import { Component, OnInit } from '@angular/core';

import * as Services from '@shared/core/services';
import { Controllers } from '@shared/core/controllers';

import { CartTypeComponent } from '../cart-type.shared.component';

@Component({
    selector: 'shared-cart-for-default',
    templateUrl: './cart-for-default.shared.component.html',
    styleUrls: ['./cart-for-default.shared.component.scss']
})
export class CartForDefaultComponent extends CartTypeComponent {
    constructor(
        public controllers: Controllers,
        public cartService: Services.CartService,
        public routeService: Services.RouteService,
    ) {
        super(controllers, cartService, routeService);
    }
}
